import { render, staticRenderFns } from "./recorderMap.vue?vue&type=template&id=0c96fd68&scoped=true&"
import script from "./recorderMap.vue?vue&type=script&lang=js&"
export * from "./recorderMap.vue?vue&type=script&lang=js&"
import style0 from "./recorderMap.vue?vue&type=style&index=0&id=0c96fd68&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c96fd68",
  null
  
)

export default component.exports